import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import StatusBadge from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Loader2, MessageCircle, Check, X, BellRing } from "lucide-react";
import { toast } from "sonner";

const TABS = [{ k: "pending", l: "En attente" }, { k: "sent", l: "Envoyées" }];

export default function Notifications() {
  const [tab, setTab] = useState("pending");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get(`/notifications?status=${tab}`).then((r) => setItems(r.data.items)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, [tab]);

  const send = (n) => {
    if (n.wa_link) window.open(n.wa_link, "_blank");
    else toast.error("Numéro WhatsApp indisponible");
  };
  const markSent = async (n) => { try { await api.post(`/notifications/${n.id}/sent`); toast.success("Marquée envoyée"); load(); } catch (e) { toast.error(apiError(e.response?.data?.detail)); } };
  const dismiss = async (n) => { await api.post(`/notifications/${n.id}/dismiss`); load(); };

  return (
    <div className="space-y-5">
      <div><h1 className="text-2xl sm:text-3xl font-bold font-heading">Notifications WhatsApp</h1><p className="text-slate-500 text-sm mt-1">Messages clients à envoyer à chaque changement de statut</p></div>

      <div className="flex gap-2">
        {TABS.map((t) => (
          <button key={t.k} data-testid={`notif-tab-${t.k}`} onClick={() => setTab(t.k)} className={`px-4 py-2 rounded-lg text-sm font-medium border ${tab === t.k ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 text-slate-600"}`}>{t.l}</button>
        ))}
      </div>

      {loading ? <div className="h-40 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-brand-600" /></div> : (
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} data-testid={`notif-card-${n.id}`} className="bg-white border rounded-2xl p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-2">
                  <div className="w-9 h-9 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center"><BellRing className="w-5 h-5" /></div>
                  <div>
                    <div className="font-medium">{n.client_name} <span className="text-slate-400 font-mono text-sm">· {n.order_number}</span></div>
                    <div className="text-xs text-slate-400">{fmtDateTime(n.created_at)} · {n.whatsapp || "sans numéro"}</div>
                  </div>
                </div>
                <StatusBadge status={n.event} />
              </div>
              <p className="text-sm text-slate-600 mt-3 bg-slate-50 rounded-xl p-3">{n.message}</p>
              {tab === "pending" && (
                <div className="flex gap-2 mt-3">
                  <Button data-testid={`notif-send-${n.id}`} onClick={() => send(n)} className="flex-1 bg-emerald-600 hover:bg-emerald-700"><MessageCircle className="w-4 h-4 mr-2" /> Envoyer via WhatsApp</Button>
                  <Button data-testid={`notif-mark-${n.id}`} onClick={() => markSent(n)} variant="outline"><Check className="w-4 h-4 mr-1" /> Marquer envoyé</Button>
                  <Button data-testid={`notif-dismiss-${n.id}`} onClick={() => dismiss(n)} variant="ghost" className="text-slate-400"><X className="w-4 h-4" /></Button>
                </div>
              )}
              {tab === "sent" && n.sent_at && <div className="text-xs text-emerald-600 mt-2 flex items-center gap-1"><Check className="w-3.5 h-3.5" /> Envoyée le {fmtDateTime(n.sent_at)}</div>}
            </div>
          ))}
          {items.length === 0 && <div className="text-center py-16 bg-white border rounded-2xl text-slate-400">Aucune notification</div>}
        </div>
      )}
    </div>
  );
}
